import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StateService {

  public hasUnreadMessages = new BehaviorSubject<number>(0);
}
